import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AppComponent } from '../app.component';
import { ListaofferteComponent } from '../listaofferte/listaofferte.component';
import { HomeComponent } from '../home/home.component';
import { ComodityComponent } from '../comodity/comodity.component';
import { PrivacyComponent } from '../privacy/privacy.component';
import { CertificazioneISOComponent } from '../certificazioneISO/certificazioneISO.component';
import { ChisiamoComponent } from '../chisiamo/chisiamo.component';
import { OffertaComponent } from '../offerta/offerta.component';
import { CosaFacciamoComponent } from '../cosa-facciamo/cosa-facciamo.component';
import { FaqComponent } from '../faqs/faq.component';
import { FineMercatoTutelatoComponent } from '../fine-mercato-tutelato/fine-mercato-tutelato.component';
import { TerminiCondizioniComponent } from '../termini-condizioni/termini-condizioni.component';
import { PercheSceglierciComponent } from '../perche-sceglierci/perche-sceglierci.component';
import { PreventivoComponent } from '../preventivo/preventivo.component';
import { LandingPageCanoneStopComponent } from '../landing-page-canone-stop/landing-page-canone-stop.component';
import { LandingPageComparatoreComponent } from '../landing-page-comparatore/landing-page-comparatore.component';
import { LandingPageContattamiComponent } from '../landing-page-contattami/landing-page-contattami.component';
import { CanoneRaiComponent } from '../canone-rai/Canone-rai.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent


    }
    ,

    {
        path: 'Home',
        component: HomeComponent

    },

    {
        path: 'Comparatore',
        component: PreventivoComponent,
        data: { origine: 1 }

    }
    ,
    {
        path: 'Comparatore/:idcomodity',
        component: PreventivoComponent,
        data: { origine: 1 }

    }
    ,

    {
        path: 'ComparatoreAdmin',
        component: PreventivoComponent,
        data: { origine: 2 }

    },

    {
        path: 'ComparatoreAdmin/:idcomodity',
        component: PreventivoComponent,
        data: { origine: 2 }

    }

    ,
    {
        path: 'Comodity/:id',
        component: ComodityComponent
    },
    {
        path: 'ListaOfferte/:idcomodity/:idfornitore',
        component: ListaofferteComponent
    }
    ,
    {
        path: 'Privacy',
        component: PrivacyComponent
    }
    ,
    {
      path: 'CertificazioneISO',
      component: CertificazioneISOComponent
    }
    ,
    {
        path: 'ChiSiamo',
        component: ChisiamoComponent
    }
    ,
    {
        path: 'Offerta/:idofferta',
        component: OffertaComponent
    },
    {
        path: 'CosaFacciamo',
        component: CosaFacciamoComponent
    }
    ,
    {
        path: 'FAQ',
        component: FaqComponent
    },
    {
        path: 'FineMercatoTutelato',
        component: FineMercatoTutelatoComponent
    },
    {
       path: 'CanoneRai',
       component: CanoneRaiComponent
    },
    {
        path: 'TerminiCondizioni',
        component: TerminiCondizioniComponent
    },
    {
        path: 'Perche-sceglierci',
        component: PercheSceglierciComponent
    },
    {
        path: 'Landing-page-canone-stop',
        component: LandingPageCanoneStopComponent
    },
    {
        path: 'Landing-page-comparatore',
        component: LandingPageComparatoreComponent
    },
    {
        path: 'Landing-page-contattami',
        component: LandingPageContattamiComponent
    },

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})
export class AppRoutingModule { }





// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts